export default input => {
  if (input && (input.toString() == 'true' || input.toString() == '1')) {
    return true
  } else {
    return false
  }
}
